import AccordionDemo from './accordion';
import AlertDemo from './alert';
import BreadcrumbsDemo from './breadcrumbs';
import ButtonDemo from './button';
import ButtonGroupDemo from './buttonGroup';
import CardDemo from './card';
import CarouselDemo from './carousel';
import CheckboxDemo from './checkbox';
import CopyDemo from './copy';
import ColorsDemo from './colors';
import CodeBlockDemo from './codeBlock';
import CurrencySelectorDemo from './currencyselector';
import DatePickerDemo from './datePicker';
import DocumentationDemo from './documentation';
import DragAndDropDemo from './draganddrop';
import DrawerDemo from './drawer';
import DropdownDemo from './dropdown';
import FlexBoxDemo from './flexbox';
import FourOhFourDemo from './fourohfour';
import LabelDemo from './label';
import ModalDemo from './modal';
import NavTabDemo from './navtab';
import PaginationDemo from './pagination';
import PhoneDemo from './phone';
import ProgressBarDemo from './progressbar';
import RadioDemo from './radio';
import RobotDemo from './robot';
import SelectDemo from './select';
import SelectWrapperDemo from './selectwrapper';
import SliderDemo from './slider';
import SnackbarDemo from './snackbar';
import SpinnerDemo from './spinner';
import StepperDemo from './stepper';
import ReactTablev6Demo from './reacttablev6';
import TableDemo from './table';
import TabMenuDemo from './tabMenu';
import TagDemo from './tag';
import TabCardDemo from './tabcard';
import TextFieldDemo from './textfield';
import ToggleDemo from './toggle';
import TooltipDemo from './tooltip';
import InlineEditDemo from './inlineEdit';
import TextAreaDemo from './textarea';

const components = [
  {
    component: AccordionDemo,
    displayName: 'Accordion',
    route: '/accordion',
  },
  {
    component: AlertDemo,
    displayName: 'Alert',
    route: '/alert',
  },
  {
    component: BreadcrumbsDemo,
    displayName: 'Breadcrumbs',
    route: '/breadcrumbs',
  },
  {
    component: ButtonDemo,
    displayName: 'Button',
    route: '/button',
  },
  {
    component: ButtonGroupDemo,
    displayName: 'Button Group',
    route: '/buttonGroup',
  },
  {
    component: CardDemo,
    displayName: 'Card',
    route: '/card',
  },
  {
    component: CarouselDemo,
    displayName: 'Carousel',
    route: '/carousel',
  },
  {
    component: CheckboxDemo,
    displayName: 'Checkbox',
    route: '/checkbox',
  },
  {
    component: CodeBlockDemo,
    displayName: 'CodeBlock',
    route: '/codeBlock',
  },
  {
    component: ColorsDemo,
    displayName: 'Colors',
    route: '/colors',
  },
  {
    component: CopyDemo,
    displayName: 'Copy',
    route: '/copy',
  },
  {
    component: CurrencySelectorDemo,
    displayName: 'Currency Selector',
    route: '/currencyselector',
  },
  {
    component: DatePickerDemo,
    displayName: 'Date Picker',
    route: '/datepicker',
  },
  {
    component: DocumentationDemo,
    displayName: 'Documentation',
    route: '/documentation',
  },
  {
    component: DragAndDropDemo,
    displayName: 'Drag and Drop',
    route: '/draganddrop',
  },
  {
    component: DrawerDemo,
    displayName: 'Drawer',
    route: '/drawer',
  },
  {
    component: DropdownDemo,
    displayName: 'Dropdown',
    route: '/dropdown',
  },
  {
    component: FlexBoxDemo,
    displayName: 'FlexBox',
    route: '/flexbox',
  },
  {
    component: FourOhFourDemo,
    displayName: '404',
    route: '/404',
  },
  {
    component: InlineEditDemo,
    displayName: 'Inline Edit',
    route: '/inline-edit',
  },
  {
    component: LabelDemo,
    displayName: 'Label',
    route: '/label',
  },
  {
    component: ModalDemo,
    displayName: 'Modal',
    route: '/modal',
  },
  {
    component: NavTabDemo,
    displayName: 'NavTab',
    route: '/navtab',
  },
  {
    component: PaginationDemo,
    displayName: 'Pagination',
    route: '/pagination',
  },
  {
    component: PhoneDemo,
    displayName: 'Phone',
    route: '/phone',
  },
  {
    component: ProgressBarDemo,
    displayName: 'Progress Bar',
    route: '/progressbar',
  },
  {
    component: RadioDemo,
    displayName: 'Radio',
    route: '/radio',
  },
  {
    component: RobotDemo,
    displayName: 'Robot',
    route: '/robot',
  },
  {
    component: SelectDemo,
    displayName: 'Select',
    route: '/select',
  },
  {
    component: SelectWrapperDemo,
    displayName: 'Select Wrapper',
    route: '/select-wrapper',
  },
  {
    component: SliderDemo,
    displayName: 'Slider',
    route: '/slider',
  },
  {
    component: SnackbarDemo,
    displayName: 'Snackbar',
    route: '/snackbar',
  },
  {
    component: SpinnerDemo,
    displayName: 'Spinner',
    route: '/spinner',
  },
  {
    component: StepperDemo,
    displayName: 'Stepper',
    route: '/stepper',
  },
  {
    component: TableDemo,
    displayName: 'Table',
    route: '/table',
  },
  {
    component: ReactTablev6Demo,
    displayName: 'ReactTableV6',
    route: '/reacttablev6',
  },
  {
    component: TabMenuDemo,
    displayName: 'Tab Menu',
    route: '/tab-menu',
  },
  {
    component: TabCardDemo,
    displayName: 'Tab Card',
    route: '/tab-card',
  },
  {
    component: TagDemo,
    displayName: 'Tag',
    route: '/tag',
  },
  {
    component: TextFieldDemo,
    displayName: 'Text Field',
    route: '/text-field',
  },
  {
    component: TextAreaDemo,
    displayName: 'Text Area',
    route: '/text-area',
  },
  {
    component: ToggleDemo,
    displayName: 'Toggle',
    route: '/toggle',
  },
  {
    component: TooltipDemo,
    displayName: 'Tooltip',
    route: '/tooltip',
  },
];

export default components;
